// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Modal = require("../ui-utils/Modal.bs.js");
var React = require("react");
var UseTabs = require("../ui-utils/UseTabs.bs.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var MM_cmp_editor = require("./MM_cmp_editor.bs.js");
var MM_cmp_settings = require("./MM_cmp_settings.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/Expln_React_Column.bs.js");
var MM_cmp_click_counter = require("./MM_cmp_click_counter.bs.js");
var ContentWithStickyHeader = require("../ui-utils/ContentWithStickyHeader.bs.js");
var MM_cmp_context_selector = require("./MM_cmp_context_selector.bs.js");

function createInitialState(settingsLocStor) {
  return {
          ctx: MM_context.createContext(undefined, undefined),
          ctxV: 0,
          settings: Belt_Option.getWithDefault(settingsLocStor, MM_cmp_settings.createDefaultSettings(undefined)),
          settingsV: 0
        };
}

function setCtx(st, ctx) {
  return {
          ctx: ctx,
          ctxV: st.ctxV + 1 | 0,
          settings: st.settings,
          settingsV: st.settingsV
        };
}

function setSettings(st, settings) {
  return {
          ctx: st.ctx,
          ctxV: st.ctxV,
          settings: settings,
          settingsV: st.settingsV + 1 | 0
        };
}

function MM_cmp_root(Props) {
  var modalRef = Modal.useModalRef(undefined);
  var match = UseTabs.useTabs(undefined);
  var updateTabs = match.updateTabs;
  var activeTabId = match.activeTabId;
  var tabs = match.tabs;
  var removeTab = match.removeTab;
  var match$1 = React.useState(function () {
        return createInitialState(MM_cmp_settings.settingsReadFromLocStor("settings"));
      });
  var setState = match$1[1];
  var state = match$1[0];
  var onContextWasUpdated = function (newCtx) {
    Curry._1(setState, (function (__x) {
            return setCtx(__x, newCtx);
          }));
    tabs.forEach(function (tab) {
          var match = tab.data;
          if (typeof match === "number") {
            return ;
          } else {
            return Curry._1(removeTab, tab.id);
          }
        });
  };
  React.useEffect((function () {
          Curry._1(updateTabs, (function (st) {
                  if (UseTabs.getTabs(st).length !== 0) {
                    return st;
                  }
                  var match = UseTabs.addTab(st, "Settings", false, /* Settings */0);
                  var match$1 = UseTabs.addTab(match[0], "Editor", false, /* Editor */1);
                  return UseTabs.openTab(match$1[0], match$1[1]);
                }));
        }), []);
  return React.createElement(ContentWithStickyHeader.make, {
              top: 0,
              header: React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(MM_cmp_context_selector.make, {
                        onChange: onContextWasUpdated,
                        modalRef: modalRef
                      }), Curry._1(match.renderTabs, undefined)),
              content: (function (contentTop) {
                  return React.createElement(Expln_React_Column.make, {
                              children: null
                            }, tabs.map(function (__x) {
                                  var match = __x.data;
                                  var tmp;
                                  if (typeof match === "number") {
                                    switch (match) {
                                      case /* Settings */0 :
                                          tmp = React.createElement(MM_cmp_settings.make, {
                                                modalRef: modalRef,
                                                ctx: state.ctx,
                                                initialSettings: state.settings,
                                                onChange: (function (newSettings) {
                                                    Curry._1(setState, (function (__x) {
                                                            return setSettings(__x, newSettings);
                                                          }));
                                                  })
                                              });
                                          break;
                                      case /* Editor */1 :
                                          tmp = React.createElement(MM_cmp_editor.make, {
                                                modalRef: modalRef,
                                                settingsV: state.settingsV,
                                                settings: state.settings,
                                                preCtxV: state.ctxV,
                                                preCtx: state.ctx,
                                                top: contentTop
                                              });
                                          break;
                                      case /* Search */2 :
                                          tmp = React.createElement(MM_cmp_click_counter.make, {
                                                title: "Search"
                                              });
                                          break;
                                      
                                    }
                                  } else {
                                    tmp = React.createElement(MM_cmp_click_counter.make, {
                                          title: match.label
                                        });
                                  }
                                  return React.createElement("div", {
                                              key: __x.id,
                                              style: {
                                                display: __x.id === activeTabId ? "block" : "none"
                                              }
                                            }, tmp);
                                }), React.createElement(Modal.make, {
                                  modalRef: modalRef
                                }));
                })
            });
}

var make = MM_cmp_root;

exports.createInitialState = createInitialState;
exports.setCtx = setCtx;
exports.setSettings = setSettings;
exports.make = make;
/* Modal Not a pure module */
